import { render, staticRenderFns } from "./TopicPhase.vue?vue&type=template&id=ea120fa2&scoped=true&"
import script from "./TopicPhase.vue?vue&type=script&lang=js&"
export * from "./TopicPhase.vue?vue&type=script&lang=js&"
import style0 from "./TopicPhase.vue?vue&type=style&index=0&id=ea120fa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea120fa2",
  null
  
)

export default component.exports